import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import Grid from '@mui/material/Grid';
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export default function DinamicDateFields({ fields = [], formData = {}, handleInputChange }) {
  return (
    <div>
      {fields.length > 0 ? (
        fields.map((field, index) => {
          const rawValue = formData[field.codigo] ?? field.valor ?? '';

          const value =
            field.tipo === "date" && rawValue
              ? dayjs(rawValue, "YYYY-MM-DD", true)
              : null;

          const today = dayjs();
          const threeMonthsAgo = dayjs().subtract(12, "month");

          return (
            <div key={index}>
              <label>{field.label}:</label>

              {field.tipo === 'select' ? (
                <Autocomplete
                  options={field.options}
                  getOptionLabel={(option) => option}
                  renderInput={(params) => (
                    <TextField {...params} label={field.label} variant="standard" fullWidth />
                  )}
                  onChange={(event, newValue) => {
                    handleInputChange({
                      target: { name: field.codigo, value: newValue || '' },
                    });
                  }}
                />
              ) : field.tipo === 'date' ? (
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                  <DatePicker
                    label={field.label}
                    format="DD/MM/YYYY"
                    value={value && value.isValid() ? value : null}
                    sx={{ width: "100%" }}
                    slotProps={{ textField: { variant: "standard", fullWidth: true } }}
                    minDate={threeMonthsAgo}
                    maxDate={today}
                    onChange={(newValue) => {
                      handleInputChange({
                        target: {
                          name: field.codigo,
                          value: newValue && newValue.isValid()
                            ? newValue.format("YYYY-MM-DD")
                            : "",
                        },
                      });
                    }}
                  />
                </LocalizationProvider>
              ) : null}
            </div>
          );
        })
      ) : (
        <p>No hay campos disponibles.</p>
      )}
    </div>
  );
}

/*export default function DinamicDateFields({ fields = [], formData, handleInputChange }) {
  return (
    <div>
      {fields.length > 0 ? (
        fields.map((field, index) => {

          // Convertir valor a objeto dayjs
          // const value = field.tipo === "date" && field.valor
          //   ? dayjs(field.valor)
          //   : null;

          const value = field.tipo === "date" && formData[field.codigo]
            ? dayjs(formData[field.codigo])
            : null;

          // Fechas mínimas / máximas
          const today = dayjs();
          const threeMonthsAgo = dayjs().subtract(12, "month");

          return (
            <div key={index}>
              <label>{field.label}:</label>

              {field.tipo === 'select' ? (
                <Autocomplete
                  options={field.options}
                  getOptionLabel={(option) => option}
                  renderInput={(params) => (
                    <TextField {...params} label={field.label} variant="standard" fullWidth />
                  )}
                  onChange={(event, newValue) => {
                    handleInputChange({
                      target: { name: field.codigo, value: newValue || '' },
                    });
                  }}
                />
              ) : field.tipo === 'date' ? (
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                  <DatePicker
                    label={field.label}
                    format="DD/MM/YYYY"
                    value={value}
                    sx={{ width: "100%" }}
                    slotProps={{ textField: { variant: "standard", fullWidth: true } }}

                    minDate={threeMonthsAgo}
                    maxDate={today}

                    onChange={(newValue) => {
                      handleInputChange({
                        target: {
                          name: field.codigo,
                          // value: newValue ? newValue.format("DD-MM-YYYY") : "",
                          value: newValue ? newValue.format("YYYY-MM-DD") : "",
                        },
                      });
                    }}
                  />
                </LocalizationProvider>
              ) : null}
            </div>
          );
        })
      ) : (
        <p>No hay campos disponibles.</p>
      )}
    </div>
  );
}*/